/* HAMEA relaunch. Plain JS, no dependencies. Every module checks for its elements, so the file runs on every HAMEA page. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const smoothstep = (p, e0, e1) => { const t = clamp((p - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  function rng(seed) { let s = seed >>> 0; return () => (s = (s * 1664525 + 1013904223) >>> 0) / 4294967296; }
  const reduceMQ = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Navigation ---------- */
  const nav = $('#nav'), burger = $('#burger');
  if (nav && burger) {
    burger.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });
    $$('#menu a').forEach(a => a.addEventListener('click', () => { nav.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }));
  }

  /* Product mega menu: click or hover on desktop, Escape and outside click close it. */
  const prodBtn = $('#prod-btn'), mega = $('#mega');
  if (prodBtn && mega) {
    let hoverT = null;
    const setMega = open => { mega.hidden = !open; prodBtn.setAttribute('aria-expanded', String(open)); nav && nav.classList.toggle('mega-open', open); };
    prodBtn.addEventListener('click', e => { e.stopPropagation(); setMega(mega.hidden); });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    [prodBtn, mega].forEach(el => {
      el.addEventListener('mouseenter', () => { if (!fine.matches) return; clearTimeout(hoverT); setMega(true); });
      el.addEventListener('mouseleave', () => { if (!fine.matches) return; hoverT = setTimeout(() => setMega(false), 220); });
    });
    document.addEventListener('click', e => { if (!mega.hidden && !mega.contains(e.target)) setMega(false); });
    addEventListener('keydown', e => { if (e.key === 'Escape' && !mega.hidden) { setMega(false); prodBtn.focus(); } });
  }

  if (nav) { let sc = null; const upd = () => { const v = scrollY > 10; if (v !== sc) { sc = v; nav.classList.toggle('scrolled', v); } }; addEventListener('scroll', upd, { passive: true }); upd(); }

  /* ---------- Reveal, live sections, divider ---------- */
  const revealIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      setTimeout(() => e.target.classList.add('done'), 1400);
      revealIO.unobserve(e.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
  $$('.reveal, .divider').forEach(el => revealIO.observe(el));
  /* Safety net: whatever is on screen is shown, even if the observer fires late (throttled tabs, slow devices). */
  let sweepQ = false;
  const revealSweep = () => {
    sweepQ = false;
    $$('.reveal:not(.in), .divider:not(.in), .pstep:not(.in)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.97 && r.bottom > 0) { el.classList.add('in'); if (!el.classList.contains('pstep')) { setTimeout(() => el.classList.add('done'), 1400); revealIO.unobserve(el); } }
    });
    $$('.pstep:not(.solved)').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < innerHeight * 0.6 && r.bottom > innerHeight * 0.3) el.classList.add('solved'); });
  };
  addEventListener('scroll', () => { if (!sweepQ) { sweepQ = true; setTimeout(revealSweep, 90); } }, { passive: true });
  addEventListener('load', revealSweep); revealSweep();
  const liveIO = new IntersectionObserver(entries => entries.forEach(e => e.target.classList.toggle('live', e.isIntersecting)), { threshold: 0.05 });
  $$('.sec, .home-hero').forEach(s => liveIO.observe(s));

  /* ---------- Rail: built from sections that carry data-rail ---------- */
  const railSecs = $$('[data-rail]');
  let rail = null, railDraw = null, railNodes = [];
  if (railSecs.length >= 3) {
    rail = document.createElement('div'); rail.className = 'rail';
    rail.innerHTML = '<svg viewBox="0 0 28 520" preserveAspectRatio="none" aria-hidden="true"><line class="track" x1="14" y1="0" x2="14" y2="520"/><line class="draw" x1="14" y1="0" x2="14" y2="520" pathLength="1" stroke-dasharray="1" stroke-dashoffset="1"/></svg><nav class="rail__nodes" aria-label="Abschnitte"></nav>';
    const list = $('.rail__nodes', rail);
    railSecs.forEach(sec => {
      const a = document.createElement('a'); a.href = '#' + sec.id; a.dataset.label = sec.dataset.rail;
      a.setAttribute('aria-label', 'Zum Abschnitt ' + sec.dataset.rail); a.innerHTML = '<i></i>';
      list.appendChild(a); railNodes.push(a);
    });
    document.body.appendChild(rail);
    railDraw = $('.draw', rail);
    let active = -1;
    const activeIO = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      const n = railSecs.indexOf(e.target);
      if (n === active) return; active = n;
      railNodes.forEach((a, i) => { a.classList.toggle('active', i === n); a.classList.toggle('passed', i < n); });
    }), { rootMargin: '-45% 0px -45% 0px' });
    railSecs.forEach(s => activeIO.observe(s));
    let shown = null, lastOff = -1;
    const railUpdate = () => {
      const first = railSecs[0].getBoundingClientRect().top + scrollY;
      const show = scrollY + innerHeight * 0.5 > first && !reduceMQ.matches;
      if (show !== shown) { shown = show; rail.classList.toggle('show', show); }
      if (!show) return;
      const end = document.documentElement.scrollHeight - innerHeight;
      const prog = clamp((scrollY - first + innerHeight * 0.5) / Math.max(1, end - first), 0, 1);
      const off = +(1 - prog).toFixed(3);
      if (Math.abs(off - lastOff) > 0.004) { lastOff = off; railDraw.style.strokeDashoffset = off; }
    };
    addEventListener('scroll', railUpdate, { passive: true }); addEventListener('resize', railUpdate); railUpdate();
  }

  /* ---------- Sticky mobile CTA ---------- */
  const sticky = $('#sticky-cta'), offerSec = $('#angebot');
  if (sticky && offerSec) {
    let offerVisible = true, pastTop = false, st = null;
    const upd = () => { const s = pastTop && !offerVisible; if (s !== st) { st = s; sticky.classList.toggle('show', s); document.documentElement.style.setProperty('--sticky-h', s && sticky.offsetHeight ? sticky.offsetHeight + 'px' : '0px'); document.documentElement.classList.toggle('sticky-on', s); } };
    new IntersectionObserver(([e]) => { offerVisible = e.isIntersecting; upd(); }, { threshold: 0.1 }).observe(offerSec);
    addEventListener('scroll', () => { const p = scrollY > innerHeight * 0.6; if (p !== pastTop) { pastTop = p; upd(); } }, { passive: true });
  }

  /* ---------- Gallery ---------- */
  const gal = $('.gallery');
  if (gal) {
    const slides = $$('.gallery__main .slide', gal), thumbs = $$('.gallery__thumbs button', gal);
    let cur = 0;
    const show = i => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((sl, j) => sl.classList.toggle('on', j === cur));
      thumbs.forEach((t, j) => t.setAttribute('aria-pressed', String(j === cur)));
    };
    thumbs.forEach((b, i) => b.addEventListener('click', () => show(i)));
    const prev = $('.gal-nav.prev', gal), next = $('.gal-nav.next', gal);
    prev && prev.addEventListener('click', () => show(cur - 1));
    next && next.addEventListener('click', () => show(cur + 1));
    let sx = null;
    const main = $('.gallery__main', gal);
    main.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
  }

  /* ---------- Offer: tiers (each tier is its own product), colour, add to cart ---------- */
  const form = $('#hm-buy');
  if (form) {
    const priceEl = $('#price'), variantName = $('#variant-name'), incl = $('#incl'), btn = $('#buy-btn'), soon = $('#soon'), idInput = $('#variant-id');
    const parse = str => Object.fromEntries((str || '').split('|').filter(Boolean).map(x => { const [k, rest] = x.split('='); const [id, av] = (rest || '').split(':'); return [k, { id, available: av === 'true' }]; }));
    const update = () => {
      const tierIn = $('input[name="tier"]:checked', form), vin = $('input[name="variant"]:checked', form);
      const tier = Number(tierIn.value), map = parse(tierIn.dataset.map), hit = map[vin.dataset.name];
      priceEl.textContent = tierIn.dataset.price;
      const wasEl = $('#price-was'), saveEl = $('#price-save'), noteEl = $('#price-note');
      const hasSave = !!tierIn.dataset.was;
      if (wasEl) { const sEl = wasEl.querySelector('s') || wasEl; sEl.textContent = tierIn.dataset.was || ''; wasEl.hidden = !hasSave; }
      if (saveEl) { saveEl.textContent = tierIn.dataset.save || ''; saveEl.hidden = !hasSave; }
      if (noteEl) { noteEl.hidden = !hasSave; noteEl.classList.toggle('t3', tier === 3); }
      variantName.textContent = vin.dataset.name;
      incl.classList.toggle('t2', tier >= 2); incl.classList.toggle('t3', tier === 3);
      const ok = !!(hit && hit.id && hit.available);
      if (hit && hit.id) idInput.value = hit.id;
      btn.disabled = !ok; soon.hidden = ok;
      btn.textContent = ok ? 'Ritual starten – ' + tierIn.dataset.price : 'Gerade nicht verfügbar';
    };
    $$('input[name="tier"], input[name="variant"]', form).forEach(i => i.addEventListener('change', update));
    update();
  }

  /* ---------- The interactive moment: hold to fill ---------- */
  const hold = $('#hold');
  let holdComplete = null;
  if (hold) {
    const holdBtn = $('#hold-btn'), holdHint = $('#hold-hint'), holdReset = $('#hold-reset'), cards = $('#mech-cards'), holdLabel = $('#hold-label');
    let hp = 0, holding = false, raf = null, last = 0, filled = false, written = -1;
    const write = v => { if (Math.abs(v - written) < 0.004 && v !== 0 && v !== 1) return; written = v; hold.style.setProperty('--p', v.toFixed(3)); };
    const complete = () => {
      filled = true; holding = false; raf = null; last = 0; write(1);
      hold.classList.add('filled'); cards && cards.classList.add('lit'); holdBtn.classList.add('done');
      holdLabel.textContent = 'Befüllt. Jetzt Scheitel für Scheitel.';
      holdHint.textContent = 'Das Öl fließt zu den Spitzen, nicht in deine Hand';
    };
    holdComplete = () => { if (!filled) { hp = 1; complete(); } };
    const tick = now => {
      const dt = Math.min(80, now - (last || now)); last = now;
      hp = clamp(hp + (holding ? dt / 1700 : -dt / 900), 0, 1);
      write(hp);
      if (hp >= 1 && !filled) { complete(); return; }
      if ((holding && hp < 1) || (!holding && hp > 0)) raf = requestAnimationFrame(tick); else { raf = null; last = 0; }
    };
    const start = e => {
      if (filled || (e && e.type === 'pointerdown' && e.button !== 0)) return;
      holding = true; holdHint.textContent = 'Halten';
      if (raf === null) raf = requestAnimationFrame(tick);
    };
    const end = () => {
      if (!holding) return; holding = false;
      if (!filled) holdHint.textContent = 'Fast. Noch einmal halten';
      if (raf === null) raf = requestAnimationFrame(tick);
    };
    holdBtn.addEventListener('pointerdown', e => { holdBtn.setPointerCapture && holdBtn.setPointerCapture(e.pointerId); start(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(t => holdBtn.addEventListener(t, end));
    holdBtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); start(); } });
    holdBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); end(); } });
    holdBtn.addEventListener('blur', end);
    holdBtn.addEventListener('contextmenu', e => e.preventDefault());
    holdReset.addEventListener('click', () => {
      filled = false; hp = 0; written = -1; write(0);
      hold.classList.remove('filled'); cards && cards.classList.remove('lit'); holdBtn.classList.remove('done');
      holdLabel.textContent = 'Halte gedrückt und befülle den Applicator';
      holdHint.textContent = 'Gedrückt halten, bis alle sieben Spitzen perlen';
    });
  }

  /* ---------- Scroll hero ---------- */
  const hero = $('#scroll-hero');
  let applyHeroMode = () => {};
  if (hero) {
    const stage = $('.stage', hero), video = $('video', hero), poster = $('.poster', hero);
    const ringWrap = $('.ring-wrap', hero), ring = $('.ring circle:last-child', hero);
    const VIDEO_URL = hero.dataset.video, POSTER_URL = hero.dataset.poster, VIDEO_BYTES = Number(hero.dataset.bytes) || 2600000;

    const bands = $$('.band', hero).map(el => {
      const [a, b] = el.dataset.range.split(',').map(Number);
      const ramp = el.dataset.ramp ? Number(el.dataset.ramp) : Math.min(0.025, (b - a) * 0.35);
      return { el, a, b, ramp, op: -1, k: -1, on: false, entrance: el.dataset.entrance };
    });
    const r = rng(7);
    bands.forEach(band => {
      const h = $('[data-split]', band.el); if (!h) return;
      const text = h.textContent.trim(), em = (h.dataset.em || '').split(',').filter(Boolean), words = text.split(/\s+/);
      const sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = text;
      h.textContent = ''; h.appendChild(sr);
      if (band.entrance === 'blur') {
        ['soft', 'sharp'].forEach(c => { const sp = document.createElement('span'); sp.className = c; sp.setAttribute('aria-hidden', 'true'); sp.textContent = text; h.appendChild(sp); });
      } else {
        const vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true');
        words.forEach((w, i) => {
          const sp = document.createElement('span'); sp.className = 'w' + (em.includes(w) ? ' em' : '');
          sp.textContent = w + (i < words.length - 1 ? ' ' : '');
          sp.style.setProperty('--th', ((i / Math.max(1, words.length)) * 0.5 + r() * 0.05).toFixed(3));
          vis.appendChild(sp);
        });
        h.appendChild(vis);
      }
    });

    const heroProgress = () => {
      const rect = hero.getBoundingClientRect(), range = rect.height - innerHeight;
      return range <= 0 ? 1 : clamp(-rect.top / range, 0, 1);
    };

    let seekBusy = false, pendingTime = null;
    const requestSeek = t => {
      if (!video.duration || !isFinite(t)) return;
      if (seekBusy) { pendingTime = t; return; }
      seekBusy = true; video.currentTime = t;
    };
    video.addEventListener('seeked', () => { seekBusy = false; if (pendingTime !== null) { const t = pendingTime; pendingTime = null; requestSeek(t); } });
    video.addEventListener('error', () => { seekBusy = false; pendingTime = null; });

    let lastScrolled = null;
    const updateCaptions = p => {
      bands.forEach((band, i) => {
        const { a, b, el } = band, f = Math.min(0.02, (b - a) / 3);
        const op = (i === 0 ? 1 : smoothstep(p, a, a + f)) * (i === bands.length - 1 ? 1 : 1 - smoothstep(p, b - f, b));
        const k = i === 0 ? Math.max(clamp((p - a) / band.ramp, 0, 1), heroInView ? 1 : 0) : clamp((p - a) / band.ramp, 0, 1);
        if (Math.abs(op - band.op) > 0.004 || (op === 0 && band.op !== 0) || (op === 1 && band.op !== 1)) { band.op = op; el.style.opacity = op.toFixed(3); }
        if (Math.abs(k - band.k) > 0.008 || (k === 1 && band.k !== 1) || (k === 0 && band.k !== 0)) {
          band.k = k; el.style.setProperty('--k', k.toFixed(3));
          el.style.setProperty('--ks', clamp((k - 0.55) * 3.2, 0, 1).toFixed(3));
          el.style.setProperty('--kb', clamp((k - 0.72) * 4.5, 0, 1).toFixed(3));
        }
        const on = op > 0.5; if (on !== band.on) { band.on = on; el.classList.toggle('is-on', on); }
      });
      const sc = p > 0.04; if (sc !== lastScrolled) { lastScrolled = sc; stage.classList.toggle('scrolled', sc); }
    };

    /* Band one assembles when the stage first comes into view (the hero is no longer the page top). */
    let heroInView = false, target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = false;
    const tick = now => {
      const dt = Math.min(100, now - (lastTick || now)); lastTick = now;
      shown += (target - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      if (Math.abs(target - shown) < 0.0005) { shown = target; rafId = null; lastTick = 0; } else rafId = requestAnimationFrame(tick);
      if (video.duration) requestSeek(shown * video.duration);
      updateCaptions(shown);
    };
    const onScroll = () => { target = heroProgress(); if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick); };
    new IntersectionObserver(([e]) => {
      heroOnScreen = e.isIntersecting;
      if (e.isIntersecting && !heroInView) { heroInView = true; bands.forEach(b => { b.k = -1; }); }
      if (heroOnScreen) onScroll();
    }, { threshold: 0.25 }).observe(stage);

    let inited = false, started = false;
    const failVideo = () => {
      const first = ringWrap.firstElementChild;
      if (first && first.classList.contains('ring')) {
        const d = document.createElement('div'); d.className = 'chev';
        d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 10l6 6 6-6"/></svg>';
        ringWrap.replaceChild(d, first);
      }
      stage.classList.add('video-failed');
    };
    const loadHeroBlob = async () => {
      const ctrl = new AbortController();
      let watchdog = setTimeout(() => ctrl.abort(), 20000);
      const res = await fetch(VIDEO_URL, { priority: 'low', signal: ctrl.signal });
      if (!res.ok || !res.body) throw new Error('video missing');
      const total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
      const reader = res.body.getReader(); const chunks = []; let got = 0, lastRing = 0;
      for (;;) {
        const { done, value } = await reader.read(); if (done) break;
        clearTimeout(watchdog); watchdog = setTimeout(() => ctrl.abort(), 20000);
        chunks.push(value); got += value.length;
        const frac = Math.min(1, got / total), now = performance.now();
        if (now - lastRing > 100 || frac === 1) { lastRing = now; ring.style.setProperty('--ld', Math.round(126 * (1 - frac))); }
      }
      clearTimeout(watchdog); ring.style.setProperty('--ld', 0);
      /* Safari and iOS only decode frames for seeking once the media is fully loaded and has been played once. */
      video.preload = 'auto';
      video.muted = true; video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
      video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
      video.load();
      let readied = false;
      const ready = () => {
        if (readied) return; readied = true;
        const p = video.play();
        const settle = () => { video.pause(); requestSeek(heroProgress() * video.duration); stage.classList.add('video-ready'); };
        if (p && p.then) p.then(settle).catch(settle); else settle();
      };
      ['loadeddata', 'canplay', 'canplaythrough'].forEach(ev => video.addEventListener(ev, ready, { once: true }));
      video.addEventListener('error', failVideo, { once: true });
    };
    const startBlob = () => { if (started) return; started = true; loadHeroBlob().catch(failVideo); };
    const initHeroOnce = () => {
      if (inited) return; inited = true;
      /* Start loading when the visitor gets near the hero, not on page load: the buy box comes first. */
      new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return; obs.disconnect();
        const img = new Image();
        img.onload = () => { poster.style.backgroundImage = `url('${POSTER_URL}')`; startBlob(); };
        img.onerror = startBlob; img.src = POSTER_URL;
        setTimeout(startBlob, 4000);
      }, { rootMargin: '150% 0px' }).observe(hero);
    };

    /* Phones scrub too (cover-cropped): the drop sits dead center, so the portrait crop keeps the action. */
    const GATES = [
      '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
      '(prefers-reduced-motion: reduce)'
    ];
    let scrubOn = false;
    const enableScrub = () => {
      if (scrubOn) return; scrubOn = true;
      initHeroOnce();
      addEventListener('scroll', onScroll, { passive: true });
      bands.forEach(b => { b.op = -1; b.k = -1; });
      updateCaptions(heroProgress()); onScroll();
    };
    const disableScrub = () => {
      if (!scrubOn) return; scrubOn = false;
      removeEventListener('scroll', onScroll);
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    };
    applyHeroMode = () => { if (GATES.some(q => matchMedia(q).matches)) disableScrub(); else enableScrub(); };
    const MQLS = GATES.map(q => matchMedia(q));
    MQLS.forEach(m => m.addEventListener('change', () => applyHeroMode()));
    hero._mqls = MQLS;
  }

  /* ---------- Pains: scroll-scrubbed strand + step reveal ---------- */
  const pains = $('.pains2');
  if (pains) {
    const pv = $('video', pains), steps = $$('.pstep', pains);
    let pReady = false, pBusy = false, pPend = null, pTarget = 0, pShown = 0, pRaf = null, pLast = 0, pOn = false, lastPP = -1;
    const pSeek = t => { if (!pv.duration) return; if (pBusy) { pPend = t; return; } pBusy = true; pv.currentTime = t; };
    pv.addEventListener('seeked', () => { pBusy = false; if (pPend !== null) { const t = pPend; pPend = null; pSeek(t); } });
    pv.addEventListener('error', () => { pBusy = false; pPend = null; });
    const prog = () => { const r = pains.getBoundingClientRect(); const range = r.height - innerHeight; return range <= 0 ? 0 : clamp(-r.top / range, 0, 1); };
    const pTick = now => {
      const dt = Math.min(100, now - (pLast || now)); pLast = now;
      pShown += (pTarget - pShown) * (1 - Math.pow(1 - 0.14, dt / 16.667));
      if (Math.abs(pTarget - pShown) < 0.0005) { pShown = pTarget; pRaf = null; pLast = 0; } else pRaf = requestAnimationFrame(pTick);
      if (pReady) pSeek(pShown * pv.duration);
      const pp = Math.round(pShown * 200) / 200;
      if (pp !== lastPP) { lastPP = pp; pains.style.setProperty('--pp', pp); }
    };
    const pScroll = () => { if (!pOn) return; pTarget = prog(); if (pRaf === null) pRaf = requestAnimationFrame(pTick); };
    addEventListener('scroll', pScroll, { passive: true });
    let pLoaded = false;
    const loadP = async () => {
      if (pLoaded || reduceMQ.matches) return; pLoaded = true;
      try {
        const res = await fetch(pains.dataset.video); if (!res.ok) throw 0;
        const blob = await res.blob();
        pv.preload = 'auto'; pv.src = URL.createObjectURL(blob); pv.load();
        const ready = () => { if (pReady) return; const p = pv.play(); const go = () => { pv.pause(); pReady = true; pains.classList.add('video-ready'); pScroll(); }; if (p && p.then) p.then(go).catch(go); else go(); };
        ['loadeddata', 'canplay'].forEach(ev => pv.addEventListener(ev, ready, { once: true }));
      } catch (e) { /* poster stays */ }
    };
    new IntersectionObserver(([e]) => { pOn = e.isIntersecting; if (pOn) { loadP(); pScroll(); } }, { rootMargin: '100% 0px' }).observe(pains);
    const inIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); }), { rootMargin: '0px 0px -8% 0px' });
    const solveIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) e.target.classList.add('solved'); }), { rootMargin: '-35% 0px -35% 0px' });
    steps.forEach(s => { inIO.observe(s); solveIO.observe(s); });
    if (reduceMQ.matches) steps.forEach(s => s.classList.add('in', 'solved'));
  }

  /* ---------- USP scroll: orbit video scrubbed, USPs appear in order ---------- */
  const usx = $('.usps2');
  if (usx) {
    const v = $('video', usx), items = $$('.usx', usx), dots = $$('.usps2__dots i', usx);
    let ready = false, busy = false, pend = null, tgt = 0, shown = 0, raf = null, last = 0, on = false, lastIdx = -2;
    const seek = t => { if (!v.duration) return; if (busy) { pend = t; return; } busy = true; v.currentTime = t; };
    v.addEventListener('seeked', () => { busy = false; if (pend !== null) { const t = pend; pend = null; seek(t); } });
    v.addEventListener('error', () => { busy = false; pend = null; });
    const prog = () => { const r = usx.getBoundingClientRect(); const range = r.height - innerHeight; return range <= 0 ? 0 : clamp(-r.top / range, 0, 1); };
    const apply = p => {
      let idx = -1;
      items.forEach((it, i) => { const at = Number(it.dataset.at); const o = p >= at; if (o) idx = i; if (o !== it.classList.contains('on')) it.classList.toggle('on', o); });
      if (idx !== lastIdx) { lastIdx = idx; items.forEach((it, i) => it.classList.toggle('now', i === idx)); dots.forEach((d, i) => d.classList.toggle('on', i <= idx)); }
    };
    const tick = now => {
      const dt = Math.min(100, now - (last || now)); last = now;
      shown += (tgt - shown) * (1 - Math.pow(1 - 0.14, dt / 16.667));
      if (Math.abs(tgt - shown) < 0.0005) { shown = tgt; raf = null; last = 0; } else raf = requestAnimationFrame(tick);
      if (ready) seek(shown * v.duration);
      apply(shown);
    };
    const onS = () => { if (!on) return; tgt = prog(); if (raf === null) raf = requestAnimationFrame(tick); };
    addEventListener('scroll', onS, { passive: true });
    let loaded = false;
    const load = async () => {
      if (loaded || reduceMQ.matches) return; loaded = true;
      try {
        const res = await fetch(usx.dataset.video); if (!res.ok) throw 0;
        const blob = await res.blob();
        v.preload = 'auto'; v.src = URL.createObjectURL(blob); v.load();
        const rd = () => { if (ready) return; const p = v.play(); const go = () => { v.pause(); ready = true; usx.classList.add('video-ready'); onS(); }; if (p && p.then) p.then(go).catch(go); else go(); };
        ['loadeddata', 'canplay'].forEach(ev => v.addEventListener(ev, rd, { once: true }));
      } catch (e) {}
    };
    new IntersectionObserver(([e]) => { on = e.isIntersecting; if (on) { load(); onS(); } }, { rootMargin: '100% 0px' }).observe(usx);
    if (reduceMQ.matches) items.forEach(it => it.classList.add('on'));
  }


  /* ---------- Pains v3: card deck. Scroll strikes the problem, reveals the solution, flicks the card away ---------- */
  const p3 = $('.pains3');
  if (p3) {
    const cards = $$('.pc3', p3), navs = $$('.pains3__nav li', p3), big = $('[data-big]', p3), N = cards.length;
    let tgt = 0, shown = 0, raf = null, last = 0, lastI = -1;
    const prog = () => { const r = p3.getBoundingClientRect(), range = r.height - innerHeight; return range <= 0 ? 1 : clamp(-r.top / range, 0, 1); };
    const apply = p => {
      const s = clamp(p * N, 0, N - 0.0001), i = Math.floor(s), t = s - i;
      const outI = i < N - 1 ? smoothstep(t, 0.74, 1) : 0;
      cards.forEach((c, k) => {
        let o = 0, d = 0, st = 0, v = 0;
        if (k < i) { o = 1; st = 1; v = 1; }
        else if (k === i) { o = outI; st = smoothstep(t, 0.06, 0.32); v = smoothstep(t, 0.2, 0.5); }
        else { d = k - i - outI; }
        c.style.setProperty('--o', o.toFixed(3)); c.style.setProperty('--d', d.toFixed(3));
        c.style.setProperty('--s', st.toFixed(3)); c.style.setProperty('--v', v.toFixed(3));
        c.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      if (i !== lastI) { lastI = i; navs.forEach((n, k) => { n.classList.toggle('on', k === i); n.classList.toggle('done', k < i); }); if (big) big.textContent = '0' + (i + 1); }
    };
    const tick = now => {
      const dt = Math.min(100, now - (last || now)); last = now;
      shown += (tgt - shown) * (1 - Math.pow(1 - 0.16, dt / 16.667));
      if (Math.abs(tgt - shown) < 0.0005) { shown = tgt; raf = null; last = 0; } else raf = requestAnimationFrame(tick);
      apply(shown);
    };
    const onS = () => { const r = p3.getBoundingClientRect(); if (r.bottom < -innerHeight || r.top > innerHeight * 2) return; tgt = prog(); if (raf === null) raf = requestAnimationFrame(tick); setTimeout(() => { if (raf !== null && Math.abs(tgt - shown) > 0.002) { shown = tgt; apply(shown); } }, 400); };
    if (reduceMQ.matches) { p3.classList.add('static'); cards.forEach(c => { ['--o', '--d'].forEach(v => c.style.setProperty(v, 0)); ['--s', '--v'].forEach(v => c.style.setProperty(v, 1)); }); }
    else { addEventListener('scroll', onS, { passive: true }); addEventListener('resize', onS); apply(prog()); shown = tgt = prog(); }
  }

  /* ---------- Scroll hints: "Weiter scrollen", step counter, progress, idle nudge ---------- */
  const coarseMQ = matchMedia('(pointer: coarse)');
  $$('[data-pin]').forEach(sec => {
    const sh = $('[data-sh]', sec); if (!sh) return;
    const cur = $('.sh__cur', sh), bar = $('.sh__bar i', sh);
    const at = (sec.dataset.shSteps || '').split(',').filter(Boolean).map(Number);
    const pst = sec.dataset.shMode === 'steps' ? $$('.pstep', sec) : [];
    const N = pst.length || at.length || 1;
    let near = false, lastK = -1, idle = null, queued = false;
    const prog = () => { const r = sec.getBoundingClientRect(), range = r.height - innerHeight; return range <= 0 ? 1 : clamp(-r.top / range, 0, 1); };
    const stepOf = p => {
      let k = 0;
      if (pst.length) { const mid = innerHeight * 0.62; pst.forEach((el, i) => { if (el.getBoundingClientRect().top < mid) k = i; }); }
      else at.forEach((a, i) => { if (p >= a - 0.001) k = i; });
      return k;
    };
    const staticMode = () => reduceMQ.matches || (sec.id === 'scroll-hero' && matchMedia('(orientation: landscape) and (pointer: coarse) and (max-height: 560px)').matches);
    const upd = () => {
      if (!queued) return; queued = false;
      const r = sec.getBoundingClientRect();
      const inside = r.top < innerHeight * 0.3 && r.bottom > innerHeight * 0.7;
      const p = prog(), k = stepOf(p), last = k >= N - 1;
      const show = inside && !last && !staticMode();
      sh.classList.toggle('show', show);
      if (k !== lastK) { lastK = k; cur.textContent = String(k + 1); sh.classList.remove('nudge'); }
      bar.style.transform = 'scaleX(' + Math.max((k + 1) / N * 0.15 + p * 0.85, (k + 1) / N * 0.999).toFixed(3) + ')';
      clearTimeout(idle); sh.classList.remove('nudge');
      if (show && coarseMQ.matches) idle = setTimeout(() => { sh.classList.add('nudge'); setTimeout(() => sh.classList.remove('nudge'), 1600); }, 3000);
    };
    const onS = () => {
      if (queued) return;
      const r = sec.getBoundingClientRect();
      near = r.bottom > -innerHeight && r.top < innerHeight * 2;
      if (!near) { if (sh.classList.contains('show')) sh.classList.remove('show'); clearTimeout(idle); return; }
      queued = true; requestAnimationFrame(upd); setTimeout(() => { if (queued) upd(); }, 120);
    };
    addEventListener('scroll', onS, { passive: true }); addEventListener('resize', onS); onS();
  });

  /* ---------- Money + cart drawer with 1-click ritual add-ons ---------- */
  const money = c => (Number(c) / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const cd = $('#cart-drawer');
  let cdData = { items: [] };
  try { cdData = JSON.parse(($('#cd-data') || {}).textContent || '{}'); } catch (e) {}
  const badge = n => { const a = $('.hd__cart'); if (!a) return; let b = $('b', a); if (n > 0) { if (!b) { b = document.createElement('b'); a.appendChild(b); } b.textContent = n; } else if (b) b.remove(); a.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel'); };
  let lastFocus = null;
  const openCd = () => { if (!cd) return; lastFocus = document.activeElement; cd.classList.add('open'); cd.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('cd-lock'); const c = $('.cd__close', cd); c && c.focus(); };
  const closeCd = () => { if (!cd) return; cd.classList.remove('open'); cd.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('cd-lock'); lastFocus && lastFocus.focus && lastFocus.focus(); };
  const renderCd = cart => {
    if (!cd) return;
    badge(cart.item_count);
    const list = $('.cd__items', cd);
    list.innerHTML = cart.items.map((it, i) => '<li class="cd__it"><img src="' + esc(it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=160' : '') + '" alt="" width="64" height="80" loading="lazy"><div class="cd__info"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (it.variant_title ? '<span>' + esc(it.variant_title) + '</span>' : '') + '<div class="cd__qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Menge verringern">−</button><b aria-live="polite">' + it.quantity + '</b><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button><button type="button" class="cd__rm" data-line="' + (i + 1) + '" data-q="0">Entfernen</button></div></div><b class="cd__lp">' + money(it.final_line_price) + '</b></li>').join('');
    cd.classList.toggle('empty', cart.item_count === 0);
    $('.cd__sum b', cd).textContent = money(cart.total_price);
    /* Add-ons: ritual products the cart does not cover yet. Bundles cover their parts. */
    const covered = new Set();
    cart.items.forEach(it => { covered.add(it.handle); const d = (cdData.items || []).find(x => x.handle === it.handle); d && (d.covers || []).forEach(h => covered.add(h)); });
    const ups = cart.item_count ? (cdData.items || []).filter(x => x.single && !covered.has(x.handle) && x.variants.some(v => v.available)) : [];
    const up = $('.cd__up', cd);
    up.hidden = ups.length === 0;
    $('ul', up).innerHTML = ups.map(x => { const vs = x.variants.filter(v => v.available); return '<li class="cd__u"><img src="' + esc(x.image) + '" alt="" width="56" height="70" loading="lazy"><div><b>' + esc(x.title) + '</b><span>' + esc(x.tag || '') + '</span>' + (vs.length > 1 ? '<select aria-label="Variante für ' + esc(x.title) + '">' + vs.map(v => '<option value="' + v.id + '">' + esc(v.title) + '</option>').join('') + '</select>' : '') + '</div><button type="button" class="cd__add" data-id="' + vs[0].id + '">+ ' + money(x.price) + '</button></li>'; }).join('');
    const allIn = (cdData.items || []).find(x => x.handle === cdData.all), hint = $('.cd__bundle', cd);
    if (hint) hint.hidden = !(allIn && cart.item_count && !covered.has(cdData.all) && ups.length > 0);
  };
  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  const addToCart = (id, qty = 1) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) }).then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)));
  if (cd) {
    $$('[data-cd-close]', cd).forEach(b => b.addEventListener('click', closeCd));
    addEventListener('keydown', e => { if (e.key === 'Escape' && cd.classList.contains('open')) closeCd(); });
    cd.addEventListener('click', e => {
      const q = e.target.closest('[data-line]');
      if (q) { fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(q.dataset.line), quantity: Math.max(0, Number(q.dataset.q)) }) }).then(r => r.json()).then(renderCd); return; }
      const a = e.target.closest('.cd__add');
      if (a) { const sel = $('select', a.closest('li')); a.disabled = true; addToCart(sel ? sel.value : a.dataset.id).then(fetchCart).then(renderCd).catch(() => { a.disabled = false; }); }
    });
    const cartLink = $('.hd__cart');
    cartLink && cartLink.addEventListener('click', e => { e.preventDefault(); fetchCart().then(renderCd).then(openCd); });
  }
  /* Every add-to-cart form on HAMEA pages adds via AJAX and opens the drawer. Falls back to a normal post without the drawer. */
  $$('form[data-hm-atc]').forEach(f => f.addEventListener('submit', e => {
    if (!cd) return;
    e.preventDefault();
    const id = (f.querySelector('[name="id"]:checked') || f.querySelector('select[name="id"]') || f.querySelector('input[name="id"]')).value;
    const btn = f.querySelector('[type="submit"]'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    addToCart(id).then(fetchCart).then(c => { renderCd(c); openCd(); })
      .catch(err => { alert((err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'); })
      .finally(() => { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }));

  /* ---------- Single product buy box: variant, price, availability ---------- */
  $$('form[data-single]').forEach(f => {
    const price = $('[data-price]', f.closest('.buy') || f), btn = $('[type="submit"]', f), vname = $('[data-vname]', f);
    const upd = () => {
      const v = $('input[name="id"]:checked', f) || $('input[name="id"]', f); if (!v) return;
      if (price && v.dataset.price) price.textContent = v.dataset.price;
      if (vname) vname.textContent = v.dataset.name || '';
      const ok = v.dataset.available !== 'false';
      btn.disabled = !ok; btn.textContent = ok ? 'Ritual starten – ' + (v.dataset.price || '') : 'Gerade nicht verfügbar';
    };
    $$('input[name="id"]', f).forEach(i => i.addEventListener('change', upd)); upd();
  });

  /* ---------- Always-on autoplay videos (muted loop). Retries on view, tab return and first interaction. ---------- */
  const keep = $$('video[data-keepplaying]');
  if (keep.length) {
    const kick = v => { v.muted = true; v.defaultMuted = true; v.playsInline = true; if (v.paused) { const p = v.play(); p && p.catch && p.catch(() => {}); } };
    keep.forEach(v => { v.setAttribute('muted', ''); kick(v); v.addEventListener('pause', () => { if (!document.hidden) setTimeout(() => kick(v), 300); }); v.addEventListener('canplay', () => kick(v)); });
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) kick(e.target); }), { rootMargin: '200px 0px' });
    keep.forEach(v => io.observe(v));
    const all = () => keep.forEach(kick);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) all(); });
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(ev => addEventListener(ev, all, { passive: true, once: true }));
    addEventListener('load', all);
  }

  /* ---------- Reduced motion, live in both directions ---------- */
  const pinToFinalStates = () => {
    $$('.reveal, .divider').forEach(el => { el.classList.add('in', 'done'); revealIO.unobserve(el); });
    holdComplete && holdComplete();
    if (rail) { railDraw.style.strokeDashoffset = 0; rail.classList.remove('show'); }
  };
  reduceMQ.addEventListener('change', e => { if (e.matches) pinToFinalStates(); else { applyHeroMode(); dispatchEvent(new Event('scroll')); } });
  if (reduceMQ.matches) pinToFinalStates();

  document.addEventListener('visibilitychange', () => document.body.classList.toggle('paused', document.hidden));
  applyHeroMode();
})();
